import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47354376"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entryInfo" }
const _hoisted_2 = { class: "pageTitle flex-ter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fanhui" }, null, -1))
const _hoisted_4 = { class: "arrival_slip" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "header flex-bwn" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "cardBox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cardTitle" }, "入荷予定伝票", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入荷予定伝票", -1))
const _hoisted_13 = { class: "cardBox" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cardTitle" }, "仕入先", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "cardBox" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cardTitle" }, "納品先情報", -1))
const _hoisted_19 = { class: "shopList" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "footer flex-bwn" }
const _hoisted_29 = { class: "receiveInfo" }
const _hoisted_30 = { class: "cardBox" }
const _hoisted_31 = { class: "cardTitle flex-bwn" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "入荷予定表", -1))
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 0,
  class: "w-full flex"
}
const _hoisted_35 = {
  key: 1,
  placeholder: "配送会社"
}
const _hoisted_36 = {
  key: 1,
  style: {"word-break":"break-all"}
}
const _hoisted_37 = { key: 1 }

import { t } from '@/plugins/i18n'
import { CircleCheck, EditPen, Message } from '@element-plus/icons-vue'
import AddProduct from './components/addProduct.vue'
import { computed, onActivated, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { request } from '@/config/request/interceptors'
import { TransferInboundInfoDTO, TransferInboundInfoItemDTO, TransferInboundQuerySkuListResp } from '@/service/overseas'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { dayjs, ElMessage, ElMessageBox } from 'element-plus'
import { statusMap, StatuEnum, statusMapType } from './data'
import { times, plus } from 'number-precision'
import EditBtn from './components/EditBtn.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const addProductRef = ref()
const inboundInfo = ref<TransferInboundInfoDTO>({})
const router = useRouter()
const transList = [{
  label: t('邮政物流'),
  value: 'YuPack'
}, {
  label: t('佐川物流'),
  value: 'Sagawa'
}, {
  label: t('黑猫物流'),
  value: 'Yamato'
}, {
  label: t('その他'),
  value: 'other'
}]

const totalNum = computed(() => {
  return inboundInfo.value?.itemList?.reduce((pre, cur) => {
    return pre + (cur.purchaseNum ?? 0)
  }, 0)
})

const totalMoney = computed(() => {
  return inboundInfo.value?.itemList?.reduce((pre, cur) => {
    return plus(pre, times(cur.price ?? 0, cur.purchaseNum ?? 0))
  }, 0)
})

const editPart = ref({
  part1: false,
  part2: false,
  part3: false,
  part4: false
})
// 保存模块
const saveArrivalSlip = async (part: 'part1' | 'part2' | 'part3' | 'part4') => {
  if (editPart.value[part]) {
    if (part === 'part1') {
      const res = await request.overseas.overseasWms.transferInboundEditBaseInfo({
        customerInboundCode: inboundInfo.value.customerInboundCode,
        inboundCode: inboundInfo.value.inboundCode!,
        orderTime: inboundInfo.value.orderTime,
        supplierName: inboundInfo.value.supplierName,
        supplierAddress: inboundInfo.value.supplierAddress
      })
    } else if (part === 'part2') {
      const res = await request.overseas.overseasWms.transferInboundEditLogisticInfo({
        expectedTime: inboundInfo.value.expectedTime,
        inboundCode: inboundInfo.value.inboundCode!,
        logisticsCompanyCode: inboundInfo.value.logisticsCompanyCode,
        trackingNumber: inboundInfo.value.trackingNumber,
        inboundRemark: inboundInfo.value.inboundRemark,
        logisticsCompanyName: inboundInfo.value.logisticsCompanyCode !== 'other' ? transList.find(i => i.value === inboundInfo.value.logisticsCompanyCode)?.label : inboundInfo.value.logisticsCompanyName
      })
    } else if (part === 'part3') {
      const res = await request.overseas.overseasWms.transferInboundEditDeliveryInfo({
        inboundCode: inboundInfo.value.inboundCode!,
        hopeTime: inboundInfo.value.hopeTime,
        sendRemark: inboundInfo.value.sendRemark
      })
    } else if (part === 'part4') {
      const res = await request.overseas.overseasWms.transferInboundEditRemark({
        inboundCode: inboundInfo.value.inboundCode!,
        purchaseRemark: inboundInfo.value.purchaseRemark
      })
    }
    ElMessage.success(t('保存成功'))
    editPart.value[part] = false
    getDetail()
  } else {
    editPart.value[part] = true
  }
}

const handleRemove = async (row: TransferInboundInfoItemDTO) => {
  ElMessageBox.confirm(t('是否确认删除'), t('提示'), {
    confirmButtonText: t('确认'),
    cancelButtonText: t('取消'),
    type: 'warning'
  })
    .then(async () => {
      await request.overseas.overseasWms.transferInboundRemoveItem({
        inboundCode: inboundInfo.value.inboundCode!,
        shopProductSku: row.shopProductSku
      })
      ElMessage.success(t('删除成功'))
      getDetail()
    })
}

// 新增商品
const handleAddGoods = async (data: TransferInboundQuerySkuListResp[]) => {
  const res = await request.overseas.overseasWms.transferInboundAddItem({
    inboundCode: inboundInfo.value.inboundCode!,
    shopProductSkuList: data.map(i => { return i.shopProductSku! })
  })
  if (res.success) {
    ElMessage.success(t('保存成功'))
  }
  getDetail()
}

// 编辑数量
const changeInboundNum = async (row: TransferInboundInfoItemDTO) => {
  const res = await request.overseas.overseasWms.transferInboundEditItemNums({
    inboundCode: inboundInfo.value.inboundCode!,
    purchaseNum: row.purchaseNum,
    shopProductSku: row?.shopProductSku
  })
  if (res.success) {
    ElMessage.success(t('保存成功'))
    row.editing = false
  }
  getDetail()
}

const route = useRoute()
onMounted(() => {
  getDetail()
})

const getDetail = async () => {
  const res = await request.overseas.overseasWms.transferInboundInfo({
    inboundCode: route.params.inboundCode as string
  })
  inboundInfo.value = res.data! ?? {}
}

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_unref(t)('返回')), 1)
      ]),
      _createVNode(_component_el_divider, { direction: "vertical" }),
      _createTextVNode(" 入荷予定詳細-" + _toDisplayString(_unref(route).params.inboundCode), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(inboundInfo.value.customerInboundCode), 1),
          _createElementVNode("div", null, [
            (inboundInfo.value.status === _unref(StatuEnum).PENDING_STORAGE)
              ? (_openBlock(), _createBlock(EditBtn, {
                  key: 0,
                  edit: editPart.value.part1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (saveArrivalSlip('part1')))
                }, null, 8, ["edit"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form, {
            "inline-message": true,
            "label-position": "left"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_el_divider),
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "130px",
                          label: "入荷予定コード："
                        }, {
                          default: _withCtx(() => [
                            (editPart.value.part1)
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 0,
                                  modelValue: inboundInfo.value.customerInboundCode,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inboundInfo.value.customerInboundCode) = $event))
                                }, null, 8, ["modelValue"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(inboundInfo.value.customerInboundCode ?? '-'), 1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "140px",
                          label: "入荷予定カテゴリ："
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "130px",
                          label: "ステータス："
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tag, {
                              type: _unref(statusMapType)[inboundInfo.value.status]
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(statusMap)[inboundInfo.value.status]), 1)
                              ]),
                              _: 1
                            }, 8, ["type"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "130px",
                          label: "発注日時："
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(inboundInfo.value.orderTime ?
                      _unref(dayjs)(inboundInfo.value.orderTime).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss') : '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "140px",
                          label: "完了日時："
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(inboundInfo.value?.completeTime ? _unref(dayjs)(inboundInfo.value.completeTime).add(1,
                      'hour').format('YYYY-MM-DD HH:mm:ss') : '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-width": "130px",
                          label: "更新日時："
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(inboundInfo.value?.updateTime ?
                      _unref(dayjs)(inboundInfo.value.updateTime).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
                      : '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_el_row, { gutter: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_el_divider),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "100px",
                              label: "仕入先名："
                            }, {
                              default: _withCtx(() => [
                                (editPart.value.part1)
                                  ? (_openBlock(), _createBlock(_component_el_input, {
                                      key: 0,
                                      modelValue: inboundInfo.value.supplierName,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inboundInfo.value.supplierName) = $event))
                                    }, null, 8, ["modelValue"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(inboundInfo.value.supplierName ?? "-"), 1))
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "100px",
                              label: "住所："
                            }, {
                              default: _withCtx(() => [
                                (editPart.value.part1)
                                  ? (_openBlock(), _createBlock(_component_el_input, {
                                      key: 0,
                                      modelValue: inboundInfo.value.supplierAddress,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inboundInfo.value.supplierAddress) = $event))
                                    }, null, 8, ["modelValue"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(inboundInfo.value.supplierAddress ?? '-'), 1))
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_el_divider),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "100px",
                              label: "納品先名："
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(inboundInfo.value?.receiverName ?? '-'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "100px",
                              label: "住所："
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(inboundInfo.value?.receiverAddress ?? '-'), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_table, {
        data: inboundInfo.value?.itemList ?? [{}, {}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "productSku",
            label: _unref(t)('商品コード')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "productName",
            label: _unref(t)('商品名')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "price",
            label: _unref(t)('単価')
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.price) + "円 （税込）", 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "purchaseNum",
            label: _unref(t)('数量（件）')
          }, {
            default: _withCtx((scope) => [
              (inboundInfo.value.status === _unref(StatuEnum).PENDING_STORAGE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _withDirectives(_createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"100px"},
                          controls: false,
                          modelValue: scope.row.purchaseNum,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.purchaseNum) = $event),
                          min: 1
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", {
                          class: "opt-btn",
                          onClick: ($event: any) => (changeInboundNum(scope.row))
                        }, _toDisplayString(_unref(t)('保存')), 9, _hoisted_21)
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, scope.row.editing]
                    ]),
                    _withDirectives(_createElementVNode("a", {
                      class: "show-one-line",
                      onClick: ($event: any) => (scope.row.editing = true)
                    }, [
                      _createTextVNode(_toDisplayString(scope.row.purchaseNum) + " ", 1),
                      _createVNode(SvgIcon, {
                        name: "pencil",
                        style: {"color":"var(--acolor)"}
                      })
                    ], 8, _hoisted_22), [
                      [_vShow, !scope.row.editing]
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(scope.row.purchaseNum), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "date",
            label: _unref(t)('状态')
          }, {
            default: _withCtx((scope) => [
              (scope.row.inboundNum)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(t)('已上架')) + "(" + _toDisplayString(scope.row.inboundNum) + ")", 1))
                : _createCommentVNode("", true),
              (scope.row.purchaseNum - scope.row.inboundNum > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(t)('待入库')) + "(" + _toDisplayString(scope.row.purchaseNum -
              scope.row.inboundNum - scope.row.cancelNum) + ")", 1))
                : _createCommentVNode("", true),
              (scope.row.cancelNum)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(t)('已取消')) + "(" + _toDisplayString(scope.row.cancelNum) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "price",
            label: _unref(t)('小計')
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(_unref(times)(scope.row.price ?? 0, scope.row.purchaseNum ?? 0)) + "円 （税込）", 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "action",
            label: _unref(t)('操作')
          }, {
            default: _withCtx((scope) => [
              (inboundInfo.value.status === _unref(StatuEnum).PENDING_STORAGE)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "opt-btn",
                    onClick: ($event: any) => (handleRemove(scope.row))
                  }, _toDisplayString(_unref(t)('删除')), 9, _hoisted_27))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", null, [
          (inboundInfo.value.status === _unref(StatuEnum).PENDING_STORAGE)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "opt-btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (addProductRef.value.show()))
              }, "+ 明細行を追加"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", null, [
          _createTextVNode("共" + _toDisplayString(_unref(totalNum)) + "件/", 1),
          _createElementVNode("span", null, "商品合計" + _toDisplayString(_unref(totalMoney)) + "円", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_el_form, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", null, [
                (inboundInfo.value.status === _unref(StatuEnum).PENDING_STORAGE)
                  ? (_openBlock(), _createBlock(EditBtn, {
                      key: 0,
                      edit: editPart.value.part2,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (saveArrivalSlip('part2')))
                    }, null, 8, ["edit"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      "label-width": "112px",
                      label: "入荷予定日："
                    }, {
                      default: _withCtx(() => [
                        (editPart.value.part2)
                          ? (_openBlock(), _createBlock(_component_el_date_picker, {
                              key: 0,
                              type: "datetime",
                              format: "YYYY-MM-DD HH:mm:ss",
                              "value-format": "YYYY-MM-DD HH:mm:ss",
                              modelValue: inboundInfo.value.expectedTime,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((inboundInfo.value.expectedTime) = $event)),
                              class: "w-full"
                            }, null, 8, ["modelValue"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(inboundInfo.value.expectedTime ?? "-"), 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      "label-width": "155px",
                      label: "配送会社："
                    }, {
                      default: _withCtx(() => [
                        (editPart.value.part2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _createVNode(_component_el_select, {
                                modelValue: inboundInfo.value.logisticsCompanyCode,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inboundInfo.value.logisticsCompanyCode) = $event)),
                                class: "w-full flex-1"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(transList, (item) => {
                                    return _createVNode(_component_el_option, {
                                      value: item.value,
                                      label: item.label,
                                      key: item.value
                                    }, null, 8, ["value", "label"])
                                  }), 64))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (inboundInfo.value.logisticsCompanyCode == 'other')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    style: {"margin-left":"10px"},
                                    modelValue: inboundInfo.value.logisticsCompanyName,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((inboundInfo.value.logisticsCompanyName) = $event))
                                  }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(inboundInfo.value?.logisticsCompanyName ?? '-'), 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      "label-width": "112px",
                      label: "送り状番号："
                    }, {
                      default: _withCtx(() => [
                        (editPart.value.part2)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: inboundInfo.value.trackingNumber,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((inboundInfo.value.trackingNumber) = $event)),
                              class: "w-full"
                            }, null, 8, ["modelValue"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(inboundInfo.value?.trackingNumber ?? '-'), 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      "label-width": "155px",
                      label: "入荷予定表特記事項："
                    }, {
                      default: _withCtx(() => [
                        (editPart.value.part2)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: inboundInfo.value.inboundRemark,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((inboundInfo.value.inboundRemark) = $event)),
                              class: "w-full"
                            }, null, 8, ["modelValue"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(inboundInfo.value.inboundRemark || '-'), 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(AddProduct, {
      onAddGoods: handleAddGoods,
      ref: (_value, _refs) => {
        _refs['addProductRef'] = _value
        addProductRef.value = _value
      }
    }, null, 512)
  ]))
}
}

})